import type { Practice } from "../api/queryFunctions/getPracticeList";

export function adaptIntakePracticeOptions(practices: Practice[]) {
  return practices
    .filter((p) => p.practice_type === "Primary Care")
    .map((p) => ({ id: p.id, name: p.name }));
}
